import ChangePasswordPage from '../pages/ChangePassword/ChangePassword';
import { Routes, Route } from 'react-router-dom';
import { UsersModule } from '../pages/UsersModule/UsersModule';
import HomePage from '../pages/HomePage/HomePage.tsx';
import { NotFoundPage } from '../pages/NotFoundPage/NotFoundPage';
import { RolesPage } from '../pages/Roles/RolesPage';
import { SkusPage } from '../pages/Skus/SkusPage';
import { ReceptionsPage } from '../pages/Receptions/ReceptionsPage';
import { PurchasesPage } from '../pages/Purchases/PurchasesPage';
import { ProvidersPage } from '../pages/ProviderPage/ProvidersPage';
import { DashboardPage } from '../pages/DashboardPage/DashboardPage';
import { SuppliersPage } from '../pages/Suppliers/SuppliersPage/SuppliersPage';
import { DispatchOrdersPage } from '../pages/DispatchOrders/DispatchOrdersPage';
import { ReportsPage } from '../pages/Reports/ReportsPage';
import { LoadingPage } from '../pages/LoadingPage/LoadingPage';
import AccessDeniedpage from '../pages/AccessDeniedPage/AccessDeniedPage';
import { NotificationsPage } from '../pages/Notifications/NotificationsPage';
import { ArticlesCategoriesPage } from '../pages/ArticlesCategories/ArticlesCategoriesPage';
import { ProviderInventoryDetailPage } from '../pages/ProviderInventoryDetail/ProviderInventoryDetailPage';
import DailyInventoryDistributionReport from '../pages/DailyInventoryDistributionReport/index';

const AppRoutes = ({ signOut, user }) => {
	return (
		<>
			<Routes>
				<Route
					path='/'
					element={<HomePage />}
				/>
				<Route
					path='/usersmodule'
					element={<UsersModule />}
				/>
				<Route
					path='/roles'
					element={<RolesPage />}
				/>
				<Route
					path='/providers'
					element={<ProvidersPage />}
				/>
				<Route
					path='/purchases'
					element={<PurchasesPage signOut={signOut} user={user} />}
				/>
				<Route
					path='/dispatch'
					element={<DispatchOrdersPage />}
				/>
				<Route
					path='/suppliers'
					element={<SuppliersPage />}
				/>
				<Route
					path='/report'
					element={<ReportsPage />}
				/>
				<Route
					path='/skus'
					element={<SkusPage />}
				/>
				<Route
					path='/reception'
					element={<ReceptionsPage />}
				/>
				<Route
					path='/dashboard'
					element={<DashboardPage />}
				/>
				<Route
					path='/notifications'
					element={<NotificationsPage />}
				/>
				<Route
					path='/articles-categories'
					element={<ArticlesCategoriesPage />}
				/>
				<Route
					path='/provider-inventory-detail'
					element={<ProviderInventoryDetailPage />}
				/>
				<Route
					path='/reports/daily-inventory-distribution'
					element={<DailyInventoryDistributionReport />}
				/>
				<Route
					path='/change-password'
					element={<ChangePasswordPage signOut={signOut} />}
				/>
				<Route
					path='/loading'
					element={<LoadingPage />}
				/>
				<Route
					path='/denied'
					element={<AccessDeniedpage />}
				/>
				<Route
					path='/404'
					element={<NotFoundPage />}
				/>
			</Routes>
		</>
	);
};

export default AppRoutes;
